import Toastr from "../../../components/Toastr"
const parent = 'SETTING_'

const DEFAULT_STATE = {
  impression_plans: [],
  impression_plan: {},
  meta: { pagination: {} },
  saving: false
}
let changes = null;
export default function impressionPlanReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  switch (action.type) {
    case `${parent}IMPRESSION_PLAN_CREATE_REJECTED`:
    case `${parent}IMPRESSION_PLAN_UPDATE_REJECTED`:
    case `${parent}IMPRESSION_PLAN_DELETE_REJECTED`:
    case `${parent}IMPRESSION_PLANS_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case `${parent}IMPRESSION_PLAN_CREATE_FULFILLED`:
    case `${parent}IMPRESSION_PLAN_UPDATE_FULFILLED`:
    case `${parent}IMPRESSION_PLAN_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      return { ...state, ...changes };

    default:
      return state;
  }
}